// extracted by mini-css-extract-plugin
module.exports = {"marketplace_shell":"styles_marketplace_shell__7TCiK"};